import dayjs from "dayjs";

export const CONTEST_FORM_MODES = Object.freeze({
  CREATE: "create",
  UPDATE: "update"
});

export const CONTEST_PLATFORM_TYPES = Object.freeze({
  LEETCODE: "leetcode",
  CODEFORCES: "codeforces",
  CODECHEF: "codechef",
  TLE: "tle",
  ATCODER: "atcoder",
  OTHER: "other"
});

export const CONTEST_DIVISION_TYPES = [
  "leetcode-biweekly",
  "leetcode-weekly",
  "codeforces-div1",
  "codeforces-div2",
  "codeforces-div3",
  "codeforces-div4",
  "codechef-contest",
  "atcoder-contest",
  "atcoder-beginner",
  "atcoder-regular",
  "atcoder-grand",
  "special-rounds"
];

export const formatDetailedDuration = (minutes) => {
  if (!minutes || minutes === 0) return "0 minutes";

  const duration = dayjs.duration(minutes, "minutes");
  return duration.humanize();
};
